<template>
      <div  style="border-left: 5px solid #E6BE8A;margin-top: 10px;margin-bottom: 10px;height: 20px;line-height: 20px;font-size: 16px;padding-left: 8px" class="tiao">{{neir}}</div>


</template>

<script>
export default {
    components:{
        tiao:'tiao'
    },
  props: ['neir'],
    methods:{
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tiao.vue